import { get as _get } from 'lodash';

import { getFlagByCategory } from '@sportOfferFederation/flags/flagMapping';
import {
    GamingRoutes,
    NavigationDestination,
    NavigationKind,
    Site,
} from '@superbet-group/web.types';
import { RouteName } from '@src/app/router/constants/RouteName';
import { currentSite } from '@src/app/utils/domainHelpers';
import { getShellConfig } from '@src/config/shell/config';

export interface NavItem {
    name: string;
    icon?: string[] | string;
    flag?: string;
    id?: string | number;
}

export interface SelectedItem {
    type: string;
    id: string | number;
}

type StructData = Record<string | number, { name: string }>;

export function getSportNavItem(selectedItem: SelectedItem, item: NavItem, promotionsTitle: string, {
    breadcrumbs,
    sports,
    tournaments,
    categories,
    virtualTournaments,
}: {
    breadcrumbs: [number, number?, number?];
    sports: StructData;
    tournaments: StructData;
    categories: StructData;
    virtualTournaments: StructData,
}) {
    /* eslint-disable no-param-reassign */
    switch (selectedItem.type) {
        case 'promotions':
            item.name = promotionsTitle;
            item.icon = ['icon--md', 'icon-sport--1002'];
            break;
        case 'sportId':
            item.name = _get(sports, [selectedItem.id, 'name'], '');
            item.icon = ['icon--md', `icon-sport-${selectedItem.id}`];
            break;
        case 'categoryId':
            item.name = _get(categories, [selectedItem.id, 'name'], '');
            item.flag = getFlagByCategory(breadcrumbs[1]!);
            item.icon = '';
            break;
        case 'tournamentId':
            item.name = _get(tournaments, [selectedItem.id, 'name'], undefined)
                ?? _get(virtualTournaments, [selectedItem.id, 'name'], '');
            item.flag = getFlagByCategory(breadcrumbs[1]!);
            item.icon = '';
            break;
        default:
            return item;
    }
    return item;
    /* eslint-enable no-param-reassign */
}

export const nativeUrlOverrides: Record<string, string> = {
    sports: 'https://napoleongames.onelink.me/jpYj/4tt6pu3d',
    casino: 'https://napoleoncasino.onelink.me/OMRr/wtlkxk3l',
};

export const napoleonHubNavigationItems = [
    {
        isSelected: false,
        dynamic: true,
        name: 'Sports',
        icon: 'sports-soccer',
        id: 'sports',
        itemClasses: [],
        destination: {
            kind: NavigationKind.MultipleDomain,
            location: {
                name: RouteName.App.Home,
            },
            site: Site.NapoleonSports,
            path: '/',
        },
        nativeUrlOverride: nativeUrlOverrides.sports,
    },
    {
        isSelected: false,
        dynamic: true,
        name: 'Casino',
        icon: 'games-games',
        id: 'casino',
        itemClasses: [],
        destination: {
            kind: NavigationKind.MultipleDomain,
            location: {
                name: GamingRoutes.MyCasinoHome,
            },
            site: Site.NapoleonCasino,
            path: '/games',
        },
        nativeUrlOverride: nativeUrlOverrides.casino,
    },
];

export function getNapoleonSiteRootItem(): NavigationDestination {
    const siteRootDestinationMap: Partial<Record<Site, NavigationDestination>> = {
        [Site.NapoleonSports]: {
            kind: NavigationKind.MultipleDomain,
            location: {
                name: RouteName.App.Home,
            },
            path: '/',
            site: Site.NapoleonSports,
        },
        [Site.NapoleonCasino]: {
            kind: NavigationKind.MultipleDomain,
            location: {
                name: GamingRoutes.MyCasinoHome,
            },
            path: '/games',
            site: Site.NapoleonCasino,
        },
        [Site.NapoleonDice]: {
            kind: NavigationKind.MultipleDomain,
            location: {
                name: GamingRoutes.MyCasinoHome,
            },
            path: '/games',
            site: Site.NapoleonDice,
        },
    };
    return siteRootDestinationMap[currentSite] ?? getShellConfig().localConfig.navigationDestinations.Logo!;
}
